import * as api from "../api";
import {
  FETCHORDERS,
  CREATEORDER,
  FETCHORDER,
  UPDATEORDER,
  DELETEORDER,
} from "../constants/actionTypes";
import { message } from "antd";

export const createOrder =
  (formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.createOrder(formData);
      dispatch({ type: CREATEORDER, data });
      if (data) {
        setLoadingButton(false);
        history("/orders");
        message.success("Order added successfully");
      }
    } catch (error) {
      if (error) {
        console.log(error?.response?.data);
        setLoadingButton(false);
        message.error(error?.response?.data);
      }
    }
  };

export const getOrders = (storeId) => async (dispatch) => {
  try {
    const { data } = await api.getOrders(storeId);
    dispatch({ type: FETCHORDERS, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const getOrder = (id) => async (dispatch) => {
  try {
    const { data } = await api.getOrder(id);
    dispatch({ type: FETCHORDER, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const updateOrder =
  (id, formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.updateOrder(id, formData);
      dispatch({ type: UPDATEORDER, payload: data });
      if (data?._id) {
        setLoadingButton(false);
        history("/orders");
        message.success("Order updated successfully");
      }
    } catch (error) {
      if (error) {
        setLoadingButton(false);
        console.log(error);
        message.error(error.response.data);
      }
    }
  };

export const deleteOrder = (id, history) => async (dispatch) => {
  try {
    const response = await api.deleteOrder(id);
    dispatch({ type: DELETEORDER, payload: id });
    if (response?.data?.success === true) {
      history("/orders");
      message.success("Order deleted successfully");
    }
  } catch (error) {
    console.log(error);
    message.error(error?.response?.data);
  }
};
